export class Configuration {
  constructor(public name: string = "", public value: string = "") {}

  static fromObject(config: any) {
    return new Configuration(config.name, config.value);
  }
}
